import { isObjectLike } from 'lodash'
import { getTask } from '../crud/integration.crud'

export const TASK_RUNNER_FAILED = 'task_runner_failed'
export const TIMER_LIMIT = 'timer_limit'

// Monitor the task for completion
export const monitorTask = (customerId, taskId, limit = 40) =>
  // eslint-disable-next-line no-async-promise-executor, consistent-return
  new Promise(async (resolve) => {
    try {
      // Default value
      let taskData = { Status: null }

      // Timer for retry logic
      let getTaskTimer

      // LIMIT
      const LIMIT = limit
      let count = 0

      // Gets the task current result status
      const getTaskStatus = async () => {
        taskData = (await getTask(customerId, { taskId })).data

        count += 1

        // Handle timeout clearing
        // eslint-disable-next-line no-underscore-dangle
        const _clearInterval = () => {
          if (getTaskTimer) {
            clearInterval(getTaskTimer)
          }
        }

        // Check for the task's response
        if (taskData.Status === 'Completed') {
          _clearInterval()
          resolve({ error: null, result: taskData })
          return false
        }
        if (taskData.Status === 'Failed') {
          let errorMessage
          console.error('Task failed', taskData)
          _clearInterval()

          // Grab the error code from the taskData
          let statusMessageObject
          try {
            statusMessageObject = JSON.parse(taskData.StatusMessage)
            if (!isObjectLike(statusMessageObject)) {
              throw new Error('StatusMessage is not an object')
            }
          } catch (err) {
            console.error('StatusMessage is not an object', taskData.StatusMessage)
            statusMessageObject = {
              errorCode: null,
              errorMessage: taskData.StatusMessage,
            }
          }

          let isErrorCode = false

          // Check for Request_BadRequest. Use the errorMessage from the probe in this case
          if (statusMessageObject.errorCode === 'Request_BadRequest') {
            errorMessage = statusMessageObject.errorMessage
          } else {
            // Translate the probes error code and output the proper relevant error message
            errorMessage = statusMessageObject.errorCode
            isErrorCode = true
          }

          const statusObject = {
            StatusMessage: errorMessage,
            Status: taskData.Status,
            isErrorCode, // used to identify can be errorMapped using mappings
            rawMessage: statusMessageObject.errorMessage,
          }

          resolve({ error: statusObject, result: null })
          return false
        }
        if (count >= LIMIT) {
          const message = 'Hit timer limit for checking task'
          console.error(message)
          _clearInterval()
          resolve({
            error: {
              StatusMessage: TIMER_LIMIT,
              Status: null,
              isErrorCode: true,
              rawMessage: message,
            },
            result: null,
          })
          return false
        }
        return true
      }
      // Check regularly for a response
      // NOTE: extended the timer as these can pile up on slower internet connections
      getTaskTimer = setInterval(async () => {
        await getTaskStatus()
      }, 3500)
    } catch (e) {
      console.error(e.message)
      resolve({
        error: {
          StatusMessage: TASK_RUNNER_FAILED,
          Status: null,
          isErrorCode: true,
          rawMessage: e.message,
        },
        result: null,
      })
      // eslint-disable-next-line no-promise-executor-return
      return false
    }
  })
